import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html'
})

export class EditAccountComponent implements OnInit {
  profilePicture: File;
  picturePreview: any;
  showErrorMsg: boolean;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public router: Router, 
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private route: ActivatedRoute) { 
        this.functionsService.setTitle('account.edit-account');
    }

  _orgData: any;
  formSubmitted: boolean = false;

  editAccountForm = this.formBuilder.group({
    name: new UntypedFormControl('', Validators.compose([
      Validators.required,
      Validators.pattern(AppConstants.noLeadingRegEx)
    ])),
    phoneNumber: new UntypedFormControl('', Validators.compose(
      AppConstants.phoneRegExReq
    )),
    extPhoneNumber: new UntypedFormControl('', Validators.compose([
     Validators.pattern(AppConstants.extPhoneNumber), 
      Validators.maxLength(8)
    ]
    )),
    logo: new UntypedFormControl(''),
    address: new UntypedFormControl('', Validators.compose([
      Validators.pattern(AppConstants.addressRegex),
      Validators.maxLength(250)
    ])),
    city: new UntypedFormControl('', Validators.compose([
      Validators.pattern(AppConstants.addressRegex),
      Validators.maxLength(50)
    ])),
    state: new UntypedFormControl('', Validators.compose([
      Validators.pattern(AppConstants.addressRegex),
      Validators.maxLength(50)
    ])),
    country: new UntypedFormControl('', Validators.compose([
      Validators.pattern(AppConstants.addressRegex),
      Validators.maxLength(60)
    ])),
    zip: new UntypedFormControl('',Validators.compose([
      Validators.pattern(AppConstants.numberRegex),
      Validators.maxLength(25)
    ])),
  });
  
  ngOnInit() { 
    //Get organization data
    this.spinner.show();
    this.showErrorMsg = false;
    this.getOrganization();
  }

  getOrganization(){
    this.apiService.getOrganization().subscribe(
      data => {
          this.editAccountForm.patchValue(data);
          this.spinner.hide();
      },
      error => {
          this.functionsService.errorHandler(error["status"]);
          //Go back to account info
          this.spinner.hide();
      }
    );
  }

  async editAccount(){
    if (!this.editAccountForm.valid) {
      this.formSubmitted = true;
      return;
    } 
    this.spinner.show();
    Object.keys(this.editAccountForm.controls).forEach((key)=>{
        this.editAccountForm.value[key] = this.editAccountForm.value[key]?this.editAccountForm.value[key].trim():"";});
    (await this.apiService.updateOrganization(this.editAccountForm.value)).subscribe(
      data => {
        this.spinner.hide();
        this.router.navigate(['../'], { relativeTo: this.route });
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  cancelEdit(){
      this.router.navigate(['../'], { relativeTo: this.route });
  }

  handleProfilePictureUpload(files: FileList) {
    if(files.item(0)){
      this.profilePicture = files.item(0);
      const reader = new FileReader();
      reader.onload = e => this.picturePreview = reader.result;
      document.getElementById("fileLabel").innerHTML = this.profilePicture.name;
      reader.readAsDataURL(this.profilePicture);
    }
  }

  get name() { return this.controlGetter('name'); }
  get phoneNumber() { return this.controlGetter('phoneNumber'); }
  get logo() { return this.controlGetter('logo'); }
  get address() { return this.controlGetter('address'); }
  get city() { return this.controlGetter('city'); }
  get state() { return this.controlGetter('state'); }
  get country() { return this.controlGetter('country'); }
  get zip() { return this.controlGetter('zip'); }
  get extPhoneNumber() { return this.controlGetter('extPhoneNumber'); }

  controlGetter(controlName) {
    const control =  this.editAccountForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
